import {
    FETCH_EWCOMPANIES_BEGIN,
    FETCH_EWCOMPANIES_SUCCESS,
    FETCH_EWCOMPANIES_FAILURE,
    SET_EWCOMPANY_SELECT,
    TOGGLE_SHOW,
    CLEAR_COS
  } from "../action/ewCompanyActions";
  
  const initialState = {
    companies: [],
    loading: false,
    error: null,
    show : false,
    globalSelect : null
  };
  
  export default function ewLoadReducer(
    state = initialState,
    action
  ) {
    switch (action.type) {

      case CLEAR_COS:
      let s = {...state}
      if(action.payload.index){
        delete s['selected' + action.payload.index]
      }else{
        let ks = Object.keys(s)
        let selKeys = ks.filter((k) => {return k.includes('selected')})
  
        selKeys.forEach(k => {
          delete s[k]
        });
      }
     

      return s

      case FETCH_EWCOMPANIES_BEGIN:
        // Mark the state as "loading" so we can show a spinner or something
        // Also, reset any errors. We're starting fresh.
        return {
          ...state,
          loading: true,
          error: null
        };
  
      case FETCH_EWCOMPANIES_SUCCESS:
        // All done: set loading "false".
        // Also, replace the groups with the ones from the server
        
        return {
          ...state,
          loading: false,
          companies: action.payload.companies
        };
  
      case FETCH_EWCOMPANIES_FAILURE:
        // The request failed, but it did stop, so set loading to "false".
        // Save the error, and we can display it somewhere
        // Since it failed, we don't have groups to display anymore, so set it empty.
        // This is up to you and your app though: maybe you want to keep the groups
        // around! Do whatever seems right.
        return {
          ...state,
          loading: false,
          error: action.payload.error,
          companies: []
        };

        case SET_EWCOMPANY_SELECT:
      
        if(!Number.isInteger(action.payload.index)){
          return {
            ...state, globalSelect : action.payload
          }
        }
        else{
          let ns = {...state}
          ns['selected' + action.payload.index] = action.payload.company
          return ns
        }

    
        
        case TOGGLE_SHOW:

        return {...state, show : !state.show}
  
      default:
        // ALWAYS have a default case in a reducer
        return state;
    }
  }
  